import https from "./https-common";

const getAllLabel = (shopDomain) => {
  let shop = shopDomain.replace(".myshopify.com", "");
  shop = shop.replace("https://", "");
  return https.get(`/labels?shop=${shop}`);
};

const getLabelById = (id) => {
  return https.get(`/labels/${id}`);
};

const updateLabel = (id, data) => {
  return https.put(`/labels/${id}`, data);
};

const LabelService = {
  getAllLabel,
  getLabelById,
  updateLabel,
};

export default LabelService;
